import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { UserAction } from 'src/app/enum/user/userActions';
import { AccessUserInfo, UserDetail, UserLocationFacility } from 'src/app/models';
import { AlertsService, FacilityService, LabActionItemService, UserService } from 'src/app/services';

@Component({
  selector: 'bart-view-lab-alert',
  templateUrl: './view-lab-alert.component.html',
  styleUrls: ['./view-lab-alert.component.scss']
})
export class ViewLabAlertComponent implements OnInit {
  userInfo: UserDetail;
  alertResult: any;
  displayMessages: any;
  messageCount: any;
  displayCount: number = 5;
  showMoreCount: number = 1;
  removeCount: number = 0;
  isShowMore: boolean = false;
  isMessageShow: boolean = false;
  userFacilityIdList: any;
  constructor(private router: Router, private _labActionItemService: LabActionItemService, private _alertsService: AlertsService, private facilityService: FacilityService, private _userService: UserService) { }

  ngOnInit() {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.getFacilities();
  }

  getFacilities() {
    try {
      this.facilityService.getUserLocationFacilities(this.userInfo.userName, (facilities: UserLocationFacility[]) => {
        if (facilities) {
          let userFacilityList: UserLocationFacility[] = facilities;
          this.userFacilityIdList = userFacilityList.map(x => x.FacilityMasterID).join(", ");
          this.loadAlertMessage();

        }
      });
    }
    catch (ex) {
      console.log(ex);
    }
  }

  loadAlertMessage() {
    try {
      let param =
      {
        "GETLABALERTACTIONITEMS":
        {
          "UserID": this.userInfo.userId,
          "BARTRoleID": this.userInfo.bartRoleId,
          "location_id_list": this.userFacilityIdList
        }
      }
      this._labActionItemService.getLabAlertActionItems(param).subscribe(response => {
        if (response != null) {
          this.alertResult = response.getLabAlertActionItems;
          this.messageCount = this.alertResult.length;
          this.displayMessage()
        }
      });
    }
    catch (ex) {
      console.log(ex);
    }
  }

  displayMessage() {
    try {
      if (this.alertResult) {
        this.displayMessages = this.alertResult.slice(0, (this.displayCount * this.showMoreCount) - this.removeCount);
        this.isShowMore = this.messageCount == (this.displayMessages != null ? this.displayMessages.length : 0) ? false : true;
        this.isMessageShow = this.alertResult.length > 0 ? true : false;
      }
    }
    catch (ex) {
      console.log(ex);
    }
  }

  showMore() {
    try {
      this.showMoreCount = this.showMoreCount + 1;
      this.displayMessage();
      
    }
    catch (ex) {
      console.log(ex);
    }
  

  }

  removeMesage(alertId: any) {
    try {
      let param =
      {
        "SETALERTACKNOWLEDGE":
        {
          "alertId": alertId,
          "userId": this.userInfo.userId
        },
        "SETALERTSTATUS":
        {
          "alertStatusCode": 'Acknowledged',
          "userId": this.userInfo.userId,
          "alertId": alertId
        }
      }
      this._alertsService.setAlertAcknowledge(param).subscribe(response => {
        this.displayMessages = this.displayMessages.filter(item => item.AlertID != alertId);
        this.alertResult = this.alertResult.filter(item => item.AlertID != alertId);
        this.messageCount = this.alertResult != null ? this.alertResult.length : 0;
        this.removeCount = this.removeCount + 1;
        if (this.alertResult != null) {
          this.isMessageShow = this.alertResult.length == 0 ? false : true;
        }
      });

      //#region User Action Audit
      this._userService.logUserAction({
        userName: this.userInfo.userName,
        userAction: UserAction.BUTTON_CLICKED,
        screenName: ScreenName.LAB_ALERTES,
        screenPath: location.pathname,
        key: 'alertId',
        value: alertId,
        eventDescription: UserActionDescription.LABS_ALERT_CLOSE_ICON_CLICKED
      });
      //#endregion
    }
    catch (ex) {
      console.log(ex);
    }
  }

  toggleAlertText(alertDetail: string, elementId: any) {
    try {
      const txtElement: HTMLElement | null = document.getElementById('txt' + elementId);
      const btnElement: HTMLElement | null = document.getElementById('btn' + elementId);

      if (btnElement.innerText == "...see less") {
        if (txtElement) {
          txtElement.innerHTML = alertDetail != null ? alertDetail.substring(0, 50) + ' ' : ' ';
          btnElement.innerText = "...see more";
        }
      
      } else if (btnElement.innerText == "...see more") {
        if (txtElement) {
          txtElement.innerHTML = alertDetail + ' ';
          btnElement.innerText = "...see less";
        }
       
      }
    }
    catch (ex) {
      console.log(ex);
    }
  }

  openMessageBox(event) {
    try {
      this.displayCount = 5;
      this.showMoreCount = 1;
      this.removeCount = 0;
      this.displayMessage();
      //#region User Action Audit
      this._userService.logUserAction({
        userName: this.userInfo.userName,
        userAction: UserAction.BUTTON_CLICKED,
        screenName: ScreenName.LAB_ALERTES,
        screenPath: location.pathname,
        key: 'UserID',
        value: this.userInfo.userId,
        eventDescription: event==true? UserActionDescription.LABS_ALERT_BELL_ICON_CLICKED:UserActionDescription.LABS_ALERT_POPUP_CLOSED
      });
      //#endregion
    }
    catch (ex) {
      console.log(ex);
    }
  }
}
